import { HTMLAttributes } from 'react';
import styles from './Icons.module.scss';
import { classes } from '../utils/cssUtils';

const ThreeDotsIcon = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => {
  const keys = Array.from({ length: 3 }, (_, index) => `key-${index}`);

  return (
    <div {...rest} className={classes(styles.showActionsBtn, className)}>
      {keys.map(key => (
        <span key={key} className={styles.dot} />
      ))}
    </div>
  );
};

export default ThreeDotsIcon;
